// src/messaging/ConversationList.jsx
// 会話の一覧（左の列）【2026-10-16】
//   ・固定した会話が上（サーバーの並び順のまま）
//   ・未読の数、最後のメッセージ、先生には「未対応／対応済み」と時間外に届いた件数
import React from 'react';
import { conversationTitle, shortTime, KIND_LABEL } from './util';
import MsgIcon from './MsgIcon';

function previewText(c, meId) {
  const m = c.last_message;
  if (!m) return 'まだメッセージはありません';
  if (m.retracted) return 'メッセージの送信を取り消しました';
  if (m.hidden) return '表示できないメッセージ';
  const who = m.sender_id && m.sender_id === meId ? 'あなた: ' : '';
  return who + (m.text || '').replace(/\s+/g, ' ');
}

export default function ConversationList({ items, activeId, meId, onOpen, loading, emptyText }) {
  if (loading && !items.length) return <div className="msg-list-empty">読み込み中...</div>;
  if (!items.length) return <div className="msg-list-empty">{emptyText || '会話はまだありません'}</div>;
  return (
    <ul className="msg-conv-list">
      {items.map(c => {
        const title = conversationTitle(c, meId);
        const isTeacherSide = c.kind === 'teacher_dm' && c.handled !== undefined;
        return (
          <li key={c.id}>
            <button type="button"
                    className={'msg-conv-item' + (c.id === activeId ? ' active' : '') + (c.status === 'stopped' || c.left ? ' dim' : '')}
                    onClick={() => onOpen(c.id)}>
              <div className="msg-conv-row1">
                {c.pinned && <MsgIcon name="pin" size={14} className="msg-pin" />}
                <span className="msg-conv-title">{title}</span>
                <span className="msg-conv-time">{c.last_message ? shortTime(c.last_message.at) : ''}</span>
              </div>
              <div className="msg-conv-row2">
                <span className="msg-conv-preview">{previewText(c, meId)}</span>
                {c.unread > 0 && <span className="msg-badge" aria-label={`未読 ${c.unread}件`}>{c.unread > 99 ? '99+' : c.unread}</span>}
              </div>
              <div className="msg-conv-tags">
                <span className="msg-tag">{KIND_LABEL[c.kind] || c.kind}</span>
                {c.class && c.kind === 'teacher_dm' && <span className="msg-tag">{c.class.name}</span>}
                {isTeacherSide && (
                  <span className={'msg-tag ' + (c.handled ? 'ok' : 'warn')}>{c.handled ? '対応済み' : '未対応'}</span>
                )}
                {isTeacherSide && c.held_off_hours > 0 && (
                  <span className="msg-tag muted">受付時間外 {c.held_off_hours}件（受付時間に通知）</span>
                )}
                {c.renewal && c.renewal.open && (
                  <span className="msg-tag warn">{c.renewal.my_vote == null ? 'まもなく停止・延長の確認' : 'まもなく停止（回答済み）'}</span>
                )}
                {c.status === 'stopped' && <span className="msg-tag muted">停止</span>}
                {c.left && c.status !== 'stopped' && <span className="msg-tag muted">抜けました</span>}
                {c.notify === 'off' && <span className="msg-tag muted">通知オフ</span>}
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
